export enum LinkReviewCategory {
  CyberLockers = 'cyberlocker',
  StreamOnDemand = 'Stream on demand',
  LiveStreams = 'streaming',
  Torrents = 'torrent',
  // SocialMedia = 'socialmedia', // TODO: temporarily remove
}

export const LinkReviewCategoryMapper = {
  [LinkReviewCategory.CyberLockers]: 'Cyber Lockers',
  [LinkReviewCategory.StreamOnDemand]: 'Stream On Demand',
  [LinkReviewCategory.LiveStreams]: 'Live Streams',
  [LinkReviewCategory.Torrents]: 'Torrents',
  // [LinkReviewCategory.SocialMedia]: 'Social Media', // TODO: temporarily remove
};

export enum LinkManagementStatus {
  OK = 'ok',
  FalsePositive = 'false positive',
  Unspecified = 'unspecified',
}

export const LinkManagementStatusMapper = {
  [LinkManagementStatus.OK]: 'OK',
  [LinkManagementStatus.FalsePositive]: 'False Positive',
  [LinkManagementStatus.Unspecified]: 'Unspecified',
};

export type EditEnterpriseLinksManagementInput = {
  status?: LinkManagementStatus;
  assetCategory?: LinkReviewCategory;
  wrongTitle?: boolean;
  bpsCategory?: LinkReviewCategory;
  deleted?: boolean;
  note?: string;
};

export type EditMultipleEnterpriseLinksManagementInput = EditEnterpriseLinksManagementInput & {
  ids: string[];
};

export interface TableLinksManagement {
  id: string;
  batch: number;
  assetTitle: string;
  assetCategory: LinkReviewCategory;
  url: string;
  domain: string;
  episodes: string;
  status: LinkManagementStatus;
  note: string;
  bps: string;
  photoUrl: string;
  email: string;
  createdAt: string;
  updatedAt: string;
}

export type LinksManagementHistoryType = {
  id: number;
  action: string;
  oldValue: any;
  newValue: any;
  userId: string;
  userName: string;
  createdAt: string;
  updatedAt: string;
};
